module.exports = {
  NODE_ENV: '"production"'
}



//////////////////
// WEBPACK FOOTER
// ./config/prod.env.js
// module id = 136
// module chunks = 10